import { flat } from "@/libs/flat";
import { JsonPrimitive } from "@/types/json";

export type ExternalField = { [key: string]: any };

type ExternalFieldInput = ExternalField | ExternalField[] | JsonPrimitive;

export const parseExternalFields = (externalFields?: ExternalFieldInput) => {
  const isPrimitive = (value?: ExternalFieldInput): value is JsonPrimitive | undefined => {
    return externalFields == null || typeof externalFields === "string" || typeof externalFields === "number";
  };

  if (isPrimitive(externalFields)) {
    return [externalFields];
  }
  const transformKeyValueBlobs = (entry: ExternalField) => {
    const [key, value] = Object.values(entry);

    return { [`${key}`]: value };
  };

  const toJSONArray = (entry: ExternalField) => {
    return Object.entries(entry).map(([key, value]) => ({ [`${key}`]: value }));
  };

  const mapNormalization = (entry: ExternalField) => {
    const [key, value] = Object.keys(entry);

    const isIrregular = key === "key" && value === "value";
    return isIrregular ? transformKeyValueBlobs(entry) : toJSONArray(entry);
  };

  const transformed = Array.isArray(externalFields)
    ? externalFields.map(mapNormalization).flat(1)
    : toJSONArray(flat(externalFields));

  return transformed;
};

export const parseMetadata = parseExternalFields;
